import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import TimeTrackingGridHourInput from '../TimeTrackingGridHourInput';
import RedistributeHourBadge from './RedistributeHourBadge';
import { parseHour } from './redistributionHelpers';

export default function RedistributeHourStepper({
  label,
  value,
  onDelta,
  badgeVariant = null,
}) {
  const committed = parseHour(value);

  const handleHourChange = useCallback((next) => {
    const delta = next - committed;
    onDelta(delta);
  }, [committed, onDelta]);

  return (
    <div className="ttg-redistribute-cost-code-stepper-inline-row">
      <div className="ttg-redistribute-cost-code-stepper-badge-slot">
        <RedistributeHourBadge variant={badgeVariant || 'neutral'} label={label} />
      </div>
      <div className="ttg-redistribute-cost-code-stepper-input-slot">
        <TimeTrackingGridHourInput
          value={committed}
          onChange={handleHourChange}
        />
      </div>
    </div>
  );
}

RedistributeHourStepper.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onDelta: PropTypes.func.isRequired,
  badgeVariant: PropTypes.oneOf(['REG', 'OT', 'DT', 'neutral']),
};

RedistributeHourStepper.defaultProps = {
  badgeVariant: null,
};
